import * as React from 'react';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import * as ReactDOM from 'react-dom';
import { Helmet } from 'react-helmet';
import { Provider } from 'react-redux';
import { configRedux } from './configRedux';
import { authActionCreators } from './ducks/auth';
import { Root } from './Root';
import { AuthService } from './services/AuthService';
import { ErrorLoggerService } from './services/ErrorLoggerService';
import { HttpService } from './services/HttpService';
declare var SERVICE_URL: string;
declare var ENVIRONMENT: 'dev' | 'test' | 'prod';

export const store = configRedux();
export const authService = new AuthService();
export const errorLogger = new ErrorLoggerService('xF9nfp4BBF/YDKUczZbVPw==', ENVIRONMENT);
const logoutFunc = () => store.dispatch(authActionCreators.logout(false));
export const httpService = new HttpService({
  authService,
  baseUrl: SERVICE_URL,
  errorLogFunc: errorLogger.sendError,
  logoutFunc
});

const defaultTitle = 'Mia - Waterfront Brands LLC';
const titleTemplate = `%s | ${defaultTitle}`;

ReactDOM.render(
  <>
    <Helmet titleTemplate={titleTemplate} defaultTitle={defaultTitle} />
    <DndProvider backend={HTML5Backend}>
      <Provider store={store}>
        <Root />
      </Provider>
    </DndProvider>
  </>,
  document.getElementById('root')
);

// if ((process.env.NODE_ENV as string) !== 'production') {
//   // tslint:disable-next-line:no-var-requires
//   const { whyDidYouUpdate } = require('why-did-you-update');
//   whyDidYouUpdate(React);
// }
